// AUTO-GENERATED fallback catalog (from `New Microsoft Excel Worksheet.xlsx`).
// Each entry: { name: string, unit: string, range: string }.
//
// The authoritative catalog lives in the backend DB (table: `lab_test_catalog`,
// endpoints under `/lab-test-catalog/`). This array is used only as an offline
// fallback when the API is unreachable, and as the seed payload sent to
// `/lab-test-catalog/seed` the first time the catalog is empty.

const FALLBACK_LAB_TESTS = [
  {
    "name": "BNP",
    "unit": "pg/mL",
    "range": "<100"
  },
  {
    "name": "NT-proBNP",
    "unit": "pg/mL",
    "range": "≤300 (HF unlikely)"
  },
  {
    "name": "Troponin I, cardiac",
    "unit": "ng/mL",
    "range": "≤0.04"
  },
  {
    "name": "Troponin T, cardiac",
    "unit": "ng/mL",
    "range": "≤0.01"
  },
  {
    "name": "Troponin I, high-sensitivity",
    "unit": "ng/L",
    "range": "Female: ≤15; Male: ≤20"
  },
  {
    "name": "Troponin T, high-sensitivity",
    "unit": "ng/L",
    "range": "Female: ≤10; Male: ≤15"
  },
  {
    "name": "CRP",
    "unit": "mg/dL",
    "range": "≤0.8"
  },
  {
    "name": "hs-CRP",
    "unit": "mg/L",
    "range": "<1.0 low CV risk; 1.0–3.0 average; >3.0 high"
  },
  {
    "name": "ESR",
    "unit": "mm/hr",
    "range": "Female: 0–20; Male: 0–15"
  },
  {
    "name": "Creatinine",
    "unit": "mg/dL",
    "range": "Female: 0.50–1.10; Male: 0.70–1.30"
  },
  {
    "name": "Creatinine (SI)",
    "unit": "µmol/L",
    "range": "Female: 44–84; Male: 62–115"
  },
  {
    "name": "BUN",
    "unit": "mg/dL",
    "range": "8–20"
  },
  {
    "name": "ACR (urine)",
    "unit": "mg/g",
    "range": "<30"
  },
  {
    "name": "Albumin, urine",
    "unit": "mg/24 hr",
    "range": "<25"
  },
  {
    "name": "eGFR",
    "unit": "mL/min/1.73 m²",
    "range": "≥60"
  },
  {
    "name": "Glucose, fasting",
    "unit": "mg/dL",
    "range": "70–99"
  },
  {
    "name": "HbA1c",
    "unit": "%",
    "range": "4.0–5.6"
  },
  {
    "name": "TSH",
    "unit": "mU/L",
    "range": "0.5–4.0"
  },
  {
    "name": "Free T4",
    "unit": "ng/dL",
    "range": "0.8–1.8"
  },
  {
    "name": "Total T4",
    "unit": "µg/dL",
    "range": "5–12"
  },
  {
    "name": "Free T3",
    "unit": "pg/mL",
    "range": "2.3–4.2"
  },
  {
    "name": "Total T3",
    "unit": "ng/dL",
    "range": "80–180"
  },
  {
    "name": "WBC",
    "unit": "x10^3/µL",
    "range": "4.0–11.0"
  },
  {
    "name": "RBC",
    "unit": "x10^6/µL",
    "range": "4.2–5.9"
  },
  {
    "name": "Hemoglobin",
    "unit": "g/dL",
    "range": "Female: 12–16; Male: 14–18"
  },
  {
    "name": "Hematocrit",
    "unit": "%",
    "range": "Female: 37–47; Male: 42–50"
  },
  {
    "name": "MCV",
    "unit": "fL",
    "range": "80–98"
  },
  {
    "name": "MCH",
    "unit": "pg",
    "range": "28–32"
  },
  {
    "name": "MCHC",
    "unit": "g/dL",
    "range": "33–36"
  },
  {
    "name": "Platelets",
    "unit": "x10^3/µL",
    "range": "150–450"
  },
  {
    "name": "Neutrophils",
    "unit": "%",
    "range": "50–70"
  },
  {
    "name": "Bands",
    "unit": "%",
    "range": "0–5"
  },
  {
    "name": "Lymphocytes",
    "unit": "%",
    "range": "30–45"
  },
  {
    "name": "Monocytes",
    "unit": "%",
    "range": "0–6"
  },
  {
    "name": "Eosinophils",
    "unit": "%",
    "range": "0–3"
  },
  {
    "name": "Basophils",
    "unit": "%",
    "range": "0–1"
  },
  {
    "name": "Sodium",
    "unit": "mEq/L",
    "range": "136–145"
  },
  {
    "name": "Potassium",
    "unit": "mEq/L",
    "range": "3.5–5.0"
  },
  {
    "name": "Chloride",
    "unit": "mEq/L",
    "range": "98–106"
  },
  {
    "name": "Bicarbonate",
    "unit": "mEq/L",
    "range": "23–28"
  },
  {
    "name": "Calcium",
    "unit": "mg/dL",
    "range": "8.6–10.2"
  },
  {
    "name": "Ionized calcium",
    "unit": "mmol/L",
    "range": "1.16–1.31"
  },
  {
    "name": "Magnesium",
    "unit": "mg/dL",
    "range": "1.6–2.6"
  },
  {
    "name": "Phosphorus",
    "unit": "mg/dL",
    "range": "3.0–4.5"
  },
  {
    "name": "ALT",
    "unit": "U/L",
    "range": "10–40"
  },
  {
    "name": "AST",
    "unit": "U/L",
    "range": "10–40"
  },
  {
    "name": "ALP",
    "unit": "U/L",
    "range": "30–120"
  },
  {
    "name": "GGT",
    "unit": "U/L",
    "range": "Female: 8–40; Male: 9–50"
  },
  {
    "name": "Bilirubin, total",
    "unit": "mg/dL",
    "range": "0.3–1.0"
  },
  {
    "name": "Bilirubin, direct",
    "unit": "mg/dL",
    "range": "0.1–0.3"
  },
  {
    "name": "Albumin",
    "unit": "g/dL",
    "range": "3.5–5.5"
  },
  {
    "name": "Total protein",
    "unit": "g/dL",
    "range": "6.0–7.8"
  },
  {
    "name": "Ferritin",
    "unit": "ng/mL",
    "range": "Female: 10–120; Male: 20–250"
  },
  {
    "name": "Iron",
    "unit": "µg/dL",
    "range": "Female: 50–170; Male: 65–175"
  },
  {
    "name": "TIBC",
    "unit": "µg/dL",
    "range": "250–400"
  },
  {
    "name": "Transferrin saturation",
    "unit": "%",
    "range": "20–50"
  },
  {
    "name": "Transferrin",
    "unit": "mg/dL",
    "range": "200–360"
  },
  {
    "name": "Total cholesterol",
    "unit": "mg/dL",
    "range": "<200 desirable"
  },
  {
    "name": "Total cholesterol (SI)",
    "unit": "mmol/L",
    "range": "<5.2"
  },
  {
    "name": "HDL-C",
    "unit": "mg/dL",
    "range": "40–60"
  },
  {
    "name": "HDL-C (SI)",
    "unit": "mmol/L",
    "range": "1.0–1.6"
  },
  {
    "name": "LDL-C",
    "unit": "mg/dL",
    "range": "<160 lab reference"
  },
  {
    "name": "LDL-C (SI)",
    "unit": "mmol/L",
    "range": "<4.2"
  },
  {
    "name": "Triglycerides",
    "unit": "mg/dL",
    "range": "<150 normal"
  },
  {
    "name": "Triglycerides (SI)",
    "unit": "mmol/L",
    "range": "<1.70 normal"
  },
  {
    "name": "Lipoprotein(a)",
    "unit": "mg/dL",
    "range": "<30 desirable"
  }
];

// ---------------------------------------------------------------------------
// Runtime catalog state (module-scoped cache)
// ---------------------------------------------------------------------------
// `_cache` holds the last-known good list from the API. Before the first
// successful load it is `null`; all sync getters fall back to
// FALLBACK_LAB_TESTS in that window so the UI never renders an empty list.
// ---------------------------------------------------------------------------

const API_BASE_URL = process.env.REACT_APP_API_URL;
const CATALOG_PATH = "/lab-test-catalog/";
const SEED_PATH = "/lab-test-catalog/seed";

let _cache = null;
let _inFlightLoad = null;
let _seedAttempted = false;

const byName = (a, b) => a.name.localeCompare(b.name);

const sanitize = (entry) => ({
  name: (entry.name || "").trim(),
  unit: entry.unit ?? null,
  range: entry.range ?? null,
  isCustom: !!entry.isCustom,
  id: entry.id,
});

/**
 * Post the embedded fallback list to the seed endpoint. Only invoked when the
 * API returns an empty catalog. Seeding is idempotent on the server.
 */
const seedCatalogFromFallback = async () => {
  if (_seedAttempted || !API_BASE_URL) return;
  _seedAttempted = true;
  try {
    await fetch(`${API_BASE_URL}${SEED_PATH}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(
        FALLBACK_LAB_TESTS.map(({ name, unit, range }) => ({ name, unit, range }))
      ),
    });
  } catch (_err) {
    // Non-fatal; in-memory fallback keeps the UI working.
  }
};

/**
 * Load the catalog from the backend. Concurrent callers share a single
 * in-flight request. Always resolves — on error it hydrates the cache from the
 * embedded fallback.
 */
export const loadLabTestCatalog = async () => {
  if (_inFlightLoad) return _inFlightLoad;

  _inFlightLoad = (async () => {
    if (!API_BASE_URL) {
      _cache = [...FALLBACK_LAB_TESTS].sort(byName);
      return _cache;
    }
    try {
      const res = await fetch(`${API_BASE_URL}${CATALOG_PATH}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (Array.isArray(data) && data.length > 0) {
        _cache = data.map(sanitize).sort(byName);
      } else {
        await seedCatalogFromFallback();
        try {
          const res2 = await fetch(`${API_BASE_URL}${CATALOG_PATH}`);
          const data2 = res2.ok ? await res2.json() : [];
          _cache = Array.isArray(data2) && data2.length > 0
            ? data2.map(sanitize).sort(byName)
            : [...FALLBACK_LAB_TESTS].sort(byName);
        } catch (_err) {
          _cache = [...FALLBACK_LAB_TESTS].sort(byName);
        }
      }
    } catch (_err) {
      _cache = [...FALLBACK_LAB_TESTS].sort(byName);
    }
    return _cache;
  })();

  try {
    return await _inFlightLoad;
  } finally {
    _inFlightLoad = null;
  }
};

/**
 * Synchronous accessor for React render paths. Returns the cache when
 * available; otherwise returns the embedded fallback.
 */
export const getAllLabTests = () => {
  if (_cache && _cache.length > 0) return _cache;
  return [...FALLBACK_LAB_TESTS].sort(byName);
};

/**
 * Add a user-authored lab test entry. POSTs to the backend and updates the
 * in-memory cache on success. Throws on failure.
 */
export const addCustomLabTest = async (test) => {
  if (!API_BASE_URL) {
    throw new Error("API base URL is not configured");
  }
  const payload = {
    name: (test.name || "").trim(),
    unit: (test.unit || "").trim() || null,
    range: (test.range || "").trim() || null,
  };
  if (!payload.name) {
    throw new Error("Test name is required.");
  }

  const res = await fetch(`${API_BASE_URL}${CATALOG_PATH}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let detail = `Request failed with status ${res.status}`;
    try {
      const body = await res.json();
      if (body?.detail) detail = body.detail;
    } catch (_err) {
      /* keep default */
    }
    throw new Error(detail);
  }

  const created = sanitize(await res.json());
  const currentCache = _cache && _cache.length > 0 ? _cache : [...FALLBACK_LAB_TESTS];
  const withoutDup = currentCache.filter(
    (t) => t.name.toLowerCase() !== created.name.toLowerCase()
  );
  _cache = [...withoutDup, created].sort(byName);
  return created;
};

export { FALLBACK_LAB_TESTS };
// Legacy default export preserved so `import LAB_TESTS from '../data/labTests'`
// in older code paths still works (returns the embedded fallback). New code
// should prefer `loadLabTestCatalog()` + `getAllLabTests()`.
export default FALLBACK_LAB_TESTS;
